/**
 * Component Registry for THE'68
 * 
 * Inherits from @vibesites-mox/theme-theme-prestige and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-mox/theme-theme-prestige/registry';
import { CobuEmbed } from './components/CobuEmbed';
import { FAQList } from './components/FAQList';

/**
 * Property-specific component overrides and additions.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  CobuEmbed,
  FAQList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
